export const chunkIntoSize = <T>(arr: T[], chunkSize: number): T[][] => {
  const numChunks = Math.ceil(arr.length / chunkSize);
  const result = [];
  for (let idx = 0; idx < numChunks; idx += 1) {
    result.push(arr.slice(idx * chunkSize, (idx + 1) * chunkSize));
  }
  return result;
};
